import { MouseEvent } from 'react';
import { AttioSortDirection } from 'dashboard409a/common/constants/analyst-dashboard';
import { ModelStatus as ModelStatusEnum } from 'dashboard409a/pages/Workboard/common/types';
import { ModelWithValuationData } from '../../services/models.types';

interface ActionOptions {
  label: string;
  callback: () => void;
  isActive: boolean;
}

export interface ModelsTableHeadColumn {
  id: string;
  label: string;
  isSortable?: boolean;
  align?: 'left' | 'right' | 'center';
  disablePadding?: boolean;
  component?: string;
  options?: ActionOptions[];
}

export interface ModelsTableHeadProps {
  order: AttioSortDirection;
  orderBy: string;
  onRequestSort: (event: MouseEvent<unknown>, property: string) => void;
  columns: ModelsTableHeadColumn[];
}

export interface ModelsTableRowProps {
  modelRow: ModelWithValuationData;
  onRowClick: (row: ModelWithValuationData, event: React.MouseEvent<HTMLTableRowElement>) => void;
  onNoteSave?: (noteContent: string, currentNote?: string) => Promise<void>;
  onStatusUpdate?: (modelId: number, newStatus: number) => void;
  statusOptions: any[];
  statusOptionsLoading: boolean;
  isNoteLoading?: boolean;
  noteError?: string | null;
}

export interface ModelsTableProps {
  isLoading: boolean;
  rows: ModelWithValuationData[];
  onNoteSave: (fulfillmentId: number, noteContent: string, currentNote?: string) => Promise<void>;
  onStatusUpdate: (modelId: number, newStatus: number) => void;
  orderBy: string;
  order: AttioSortDirection;
  onRequestSort: (event: React.MouseEvent<unknown>, property: string) => void;
  isNoteLoading?: boolean;
  noteError?: string | null;
  onRowClick: (model: ModelWithValuationData, event: React.MouseEvent<HTMLTableRowElement>) => void;
  onFiltersChange?: (filters: {
    searchParam: string;
    searchStatus: string;
    fromDate: Date | null;
    toDate: Date | null;
    userIds: number[];
  }) => void;
}

export interface ModelsStatusOption {
  value: string;
  label: string;
}

export const modelsStatusOptions: ModelsStatusOption[] = [
  { value: ModelStatusEnum.DRAFT, label: 'Draft' },
  { value: ModelStatusEnum.REVIEW, label: 'Review' },
  { value: ModelStatusEnum.IN_PROCESS_SCALAR_USA, label: 'In-process ScalarUSA' },
  { value: ModelStatusEnum.FINAL, label: 'Final' },
  { value: ModelStatusEnum.COMPLETE, label: 'COMPLETE' },
  { value: ModelStatusEnum.WAITING, label: 'WAITING' },
];
